
















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/commande/edit/EditInformation.vue'
import { getDefaultAloCommande, AloCommande } from '@/models/alo/AloCommande'
import { toStringDictionary } from '@/utils/groupBy'

@Component({
  name: 'ReadInformation',    
   props: {
    commande:{      
      default:getDefaultAloCommande()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadInformation extends Vue {
  private commande!:AloCommande
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.commande) }
}
